package com.trevorwiebe.timesheet.core.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.cancel

abstract class DisposableViewModel : ViewModel() {
    fun dispose() {
        viewModelScope.cancel()
    }
}
